module.exports = __webpack_public_path__ + "assets/img/coin-dimd.16c8bd27.png";